(ns common.opensearch.fields
  (:require
    [clojure.set :as set]
    [clojure.string :as string]
    [common.localization :as loc]
    [common.opensearch.entity-indices :as ei]
    [common.schema.data-types :as data-types]
    [common.schema.registry :as registry]
    [common.util :as cu]))

(defn dot-separated-path->keys
  [dot-separated-path]
  (when dot-separated-path
    (->> (string/split dot-separated-path #"\.")
         (map keyword))))

(def entity-name-paths
  (->> ei/entity-type->index-config
       (keep (fn [[_entity-type index-config]]
               (-> index-config
                   :name-field
                   (dot-separated-path->keys))))
       (set)))

(defn kw->str
  [k]
  (-> k
      (str)
      (subs 1)))

(defn keys->dot-separated-path
  [kws]
  (->> kws
       (map kw->str)
       (string/join ".")
       (keyword)))

(def dot-separated-entity-name-paths
  (->> entity-name-paths
       (map keys->dot-separated-path)
       (set)))

(defn dot-separated-entity-name-path?
  [k]
  (contains? dot-separated-entity-name-paths k))

(defn hit->entity-name
  [hit]
  (->> entity-name-paths
       (keep (partial get-in (:_source hit)))
       (string/join " ")))

(defn hit->id-type-title
  [hit]
  (let [test {:db/id       (-> hit
                               :_id
                               (long))
              :entity/type (-> hit
                               :_source
                               :original
                               :entity/type
                               (keyword))
              :title       (hit->entity-name hit)}]
    test))

(defn dot-separated-path->field-name
  [dot-separated-path]
  (-> dot-separated-path
      (string/split #"\.")
      (second)
      (keyword)
      (loc/tr)))

(defn strip-first-namespace
  [kw]
  (let [parts (when-let [kw-ns (namespace kw)]
                (string/split kw-ns #"\."))]
    (if-not parts
      kw
      (keyword
        (->> parts
             (rest)
             (string/join "."))
        (name kw)))))

(def ref-data-types
  #{:data.type/ref-single :data.type/ref-multi})

(def keyword-data-types
  #{:data.type/keyword :data.type/keyword-multi})

(def materialized-data-types
  (set/union keyword-data-types ref-data-types))

(defn is-materialized-field?
  [field-data-type]
  (contains? materialized-data-types field-data-type))

(def labelled-data-types
  (set/union ref-data-types
             keyword-data-types))

(def text-data-types
  (->> data-types/zapflow-data-types
       (filter (fn [[_dt m]]
                 (= :db.type/string (:datomic/type m))))
       (remove (fn [[_ m]]
                 (= :common.content-encoding/edn (:common/content-encoding m))))
       (map key)
       (set)))

(defn is-text-field?
  [field-data-type]
  (contains? text-data-types field-data-type))

(defn field-path->last-kw
  [field]
  (cond (keyword? field)
        field
        (sequential? field)
        (field-path->last-kw (last field))
        :else
        (do (println "Unknown field-path " field)
            nil)))

(defn field->os-field
  [tenant-schema field]
  (if (and (sequential? field)
           (cu/multiple? field))
    (let [associated-entity-field-str (-> field
                                          first
                                          kw->str)
          field (field->os-field tenant-schema (rest field))]
      (str associated-entity-field-str "." field))
    (let [field (if (sequential? field)
                  (first field)
                  field)
          field-schema (registry/get-field-schema tenant-schema field)
          data-type (:field/data-type field-schema)
          field-str (-> field
                        kw->str)]
      (cond
        (contains? materialized-data-types data-type)
        (str "materialized." field-str)

        ;; TODO - handle extras

        :else (str "original." field-str)))))

(defn os-field->field
  [os-field]
  (-> os-field
      (string/split #"\.")
      (last)
      (keyword)))

(defn os-field-keyword->field
  [os-field-keyword]
  (-> os-field-keyword
      kw->str
      (os-field->field)))

(defn os-field->label
  [tenant-schema os-field]
  (let [field (os-field->field os-field)
        field-schema (registry/get-field-schema tenant-schema field)]
    (get-in field-schema [:field/translations :en])))

(defn relation-attribute-key
  [relation-attribute target-entity-type attribute]
  (str (cu/kw->str relation-attribute)
       "---"
       (cu/kw->str target-entity-type)
       "---"
       attribute))

(defn os-index->entity-type
  [index-name]
  (let [parts (string/split index-name #"_")
        entity-name-parts (rest parts)
        entity-type (->> entity-name-parts
                         (string/join "-")
                         (str "entity.type/")
                         (keyword))]
    entity-type))
